<template>
  <div class="kye-report-fzkp002" @click="handleClick('cardClick')">
    <div class="fzkp002_main-cell-title">
      <div class="fzkp002_main-title-left">
        <div class="fzkp002_main-title-top">
          <div
            class="fzkp002_main-title"
            @click="handleClick('mainTitle')"
            v-events="{ eventsMap, ignoreEventName, args: ['mainTitle', data.mainTitle]}"
          >{{ data.mainTitle }}</div>
          <KyeReportCardQuestion
            class="fzkp002_main-icon1"
            :icon="data.mainIcon1"
            :popover="data.popover"
            @click="handleClick('mainIcon1')">
            <slot :name="'tooltip'"></slot>
          </KyeReportCardQuestion>
        </div>
        <div
          class="fzkp002_main-index"
          @click="handleClick('mainIndex')"
          v-events="{ eventsMap, ignoreEventName, args: ['mainIndex', data.mainIndex]}"
        >{{ data.mainIndex }}</div>
      </div>
      <img
        class="fzkp002_main-icon2"
        @click="handleClick('mainIcon2')"
        :src="data.mainIcon2 || mainIcon2"
        v-events="{ eventsMap, ignoreEventName, args: ['mainIcon2', data.mainIcon2]}"
      />
    </div>
    <div class="fzkp002_main-cell-index">
      <div :class="[toggle ? 'fzkp002_list-cell-open' : 'fzkp002_list-cell-close']">
        <div
          class="fzkp002_list-index-cell"
          :class="[`fzkp002_list-index-cell-${index}`]"
          v-for="(listItem, index) in data.list"
          :key="index">
          <div class="fzkp002_list-cell-title">
            <div
              class="fzkp002_list-title"
              @click="handleClick('listTitle', index)"
              v-events="{ eventsMap, ignoreEventName, args: ['listTitle', index, listItem.listTitle]}"
            >{{ listItem.listTitle }}</div>
            <div
              class="fzkp002_list-index"
              @click="handleClick('listIndex', index)"
              v-events="{ eventsMap, ignoreEventName, args: ['listIndex', index, listItem.listIndex]}"
            >{{ listItem.listIndex }}</div>
          </div>
          <el-progress
            class="fzkp002_list-rate"
            :show-text="false"
            :color="listItem.listRateColor"
            :percentage="listItem.listRate"
            @click="handleClick('listRate', index)"
            v-events="{ eventsMap, ignoreEventName, args: ['listRate', index, listItem.listRate]}"
          ></el-progress>
        </div>
      </div>
      <div class="fzkp002_list-toggle-cell">
        <div class="fzkp002_list-toggle" @click="toggleEvent">
          <div
            class="fzkp002_toggle-triangle"
            :class="[toggle ? 'fzkp002_toggle-triangle-up' : 'fzkp002_toggle-triangle-down']"
          ></div>
        </div>
      </div>
    </div>
    <card-popover
      :popoverConfig="popoverConfig"
    >
      <slot :name="cardPopoverSlotName"></slot>
    </card-popover>
  </div>
</template>
<script>
import mainIcon2 from '../../asset/images/fzkp002.png'
import kyeReportCardArrow from '../common/arrow.vue'
import KyeReportCardQuestion from '../common/question.vue'
export default {
  name: 'KyeReportFzkp002',
  components: {
    KyeReportCardQuestion,
    kyeReportCardArrow
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      mainIcon2,
      toggle: false,
    }
  },
  mounted() {
  },
  methods: {
    handleClick(eventName, index) {
      if (Number(index) >= 0) {
        this.$emit(eventName, index, this.data)
      } else {
        this.$emit(eventName, this.data)
      }
    },
    getIndexColor(type) {
      if (type === 'up') {
        return 'index-up-color'
      } else if (type === 'down') {
        return 'index-down-color'
      }
    },
    toggleEvent () {
      this.toggle = !this.toggle
      this.$emit('toggle', this.toggle)
    },
  }
}
</script>
<style lang="scss">
.kye-report-fzkp002 {
  @import '../../style/extend.scss';
  background: #FFFFFF;
  border-radius: 4px;
  flex-direction: column;
  cursor: pointer;
  display: flex;
  background: linear-gradient(184deg, #F7F6FF 2%, #FFFFFF 79%);
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  .fzkp002_main-cell-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 12px;
    padding: 8px 12px 0 16px;
    .fzkp002_main-icon2 {
      width: 48px;
      height: 48px;
    }
    .fzkp002_main-title-left {
      display: flex;
      flex-direction: column;
      gap: 6px;
      margin-top: 4px;
      .fzkp002_main-title-top {
        display: flex;
        flex-direction: row;
        align-items: center;
        line-height: 12px;
        font-size: 12px;
        color: #666666;
        gap: 4px;
      }
      .fzkp002_main-index {
        font-size: 24px;
        font-weight: 600;
        color: #333333;
      }
    }
  }
  .fzkp002_main-cell-index {
    display: flex;
    flex-direction: column;
    padding: 0px 16px 6px 16px;
    .fzkp002_list-cell-close {
      height: 84px;
      overflow: hidden;
    }
    .fzkp002_list-index-cell {
      margin-top: 12px;
      .fzkp002_list-cell-title {
        color: #333333;
        font-size: 12px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
      .fzkp002_list-rate {
        margin-top: 6px;
      }
    }
    .fzkp002_list-toggle-cell {
      display: flex;
      justify-content: center;
      margin-top: 10px;
      .fzkp002_list-toggle {
        width: 56px;
        height: 8px;
        border-radius: 2px;
        background: #f2f3f7;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          background: rgba(118, 83, 214, 0.2);
          // .toggle-triangle {
          //   border-color:var(--g-color-primary) !important;
          //   opacity: 1;
          // }
          .fzkp002_toggle-triangle-up {
            border-bottom: 4px solid var(--g-color-primary);
          }
          .fzkp002_toggle-triangle-down {
            border-top: 4px solid var(--g-color-primary);
          }
        }
        .fzkp002_toggle-triangle {
          width: 0;
          height: 0;
          border-left: 3px solid transparent;
          border-right: 3px solid transparent;
        }
        .fzkp002_toggle-triangle-up {
          border-bottom: 4px solid #999999;
        }
        .fzkp002_toggle-triangle-down {
          border-top: 4px solid #999999;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/card/fzkp002/index.vue